import { apiFetch } from "./client";

export interface KnowledgeItem {
  id: string;
  companyId: string;
  type: string;
  name: string;
  content: string | null;
  storageUrl: string | null;
  mimeType: string | null;
  metadata: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateKnowledgeInput {
  type: string;
  name: string;
  content?: string;
  url?: string;
}

export const knowledgeApi = {
  list: (companyId: string) =>
    apiFetch<KnowledgeItem[]>(`/companies/${companyId}/knowledge`),
  create: (companyId: string, data: CreateKnowledgeInput) =>
    apiFetch<KnowledgeItem>(`/companies/${companyId}/knowledge`, {
      method: "POST",
      body: JSON.stringify(data),
    }),
  delete: (companyId: string, id: string) =>
    apiFetch<void>(`/companies/${companyId}/knowledge/${id}`, {
      method: "DELETE",
    }),
};
